import React from "react";
import { RiDeleteBinLine } from "react-icons/ri";

export default function DeleteTeamModal({ onClose, onSubmit }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-800">
          Delete Team
        </h2>

        {/* Message */}
        <p className="mt-3 text-sm text-gray-600">
          Are you sure you want to delete this team?
          This action cannot be undone.
        </p>

        {/* Actions */}


        <div className="mt-6 flex justify-end gap-4">
          <button onClick={onClose} className="px-5 py-2 rounded-md border text-gray-700 hover:bg-gray-100 transition">Cancel</button>
          <button onClick={onSubmit} className="flex items-center gap-3 px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-1001">
            <RiDeleteBinLine size={22} />
            <span>Delete</span>
          </button>
        </div>

      </div>
    </div>
  );
}
